<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import TrackerList from "@/components/TrackerList.vue";

// Access Vuex store
const store = useStore();
const router = useRouter();

// Get user from Vuex store
const role = store.getters.getRole;

const goToTracker = () => {
  router.push('/tracker');
};
</script>

<template>
  <div class="home-container glass-panel">
    <div v-if="role==='user' || role==='admin'">
      <h1>{{ msg }}</h1>
      <p>Home page containing todo and useful links.</p>
      <h3>Tracker</h3>
      <br />
      <TrackerList @edit="goToTracker" />
      <h3>Photos</h3>
      <ul>
        <li class="li-inline">
          <a
            href="https://photos.google.com/album/AF1QipPW0W8_C5Ij9fPqupbHZrQVzuwD71ie5cYNARv9"
            target="_blank"
            rel="noopener"
          >Family</a>
        </li>
        <li class="li-inline">
          <a href="https://photos.google.com/search/Leo" target="_blank" rel="noopener">Leo</a>
        </li>
        <li class="li-inline">
          <a href="https://photos.google.com/search/Liam" target="_blank" rel="noopener">Liam</a>
        </li>
      </ul>
      <h3>Youtube</h3>
      <ul>
        <li class="li-inline">
          <a
            href="https://www.youtube.com/results?search_query=lcs+highlights+"
            target="_blank"
          >LCS Highlights</a>
        </li>
        <li class="li-inline">
          <a href="https://www.youtube.com/results?search_query=nba" target="_blank">NBA</a>
        </li>
        <li class="li-inline">
          <a href="https://www.youtube.com/results?search_query=nhl" target="_blank">NHL</a>
        </li>
        <li class="li-inline">
          <a
            href="https://www.youtube.com/results?search_query=2+hour+epic+music"
            target="_blank"
          >Music</a>
        </li>
        <li class="li-inline">
          <a
            href="https://www.youtube.com/results?search_query=cocomelon"
            target="_blank"
          >Kids Music</a>
        </li>
      </ul>
    </div>
    <div v-else>
      <h1>Welcome</h1>
      <p>Your account is currently setup as a guest, please speak to Admin to change your access level.</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
.li-inline {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: $link-color;
}
a:hover,
a:focus {
  color: $link-hover-color;
}
.home-container {
  padding: 40px;
  padding-bottom: 50px;
  margin-top: 20px;
}

.todo-list {
  margin: auto;
  width: 60%;
}

.todo-list li {
  text-align: left;
  cursor: pointer;
  position: relative;
  padding: 12px 20px;
  margin-bottom: 10px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: $text-color;
  transition: all 0.3s ease;
}

.todo-list li:nth-child(odd) {
  background: rgba(255, 255, 255, 0.03);
  color: $text-color;
}

.todo-list li:hover {
  background: rgba(6, 182, 212, 0.1);
  border-color: $cyan;
  transform: translateX(5px);
}
</style>
